import { styled } from 'goober';
import { ComponentChildren } from 'preact';

const Field = styled('div')`
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: 0;
  }
`;

const Label = styled('label')`
  display: block;
  font-size: 10px;
  font-weight: 600;
  color: var(--text-muted);
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

interface FormFieldProps {
  label: string;
  htmlFor: string;
  children: ComponentChildren;
  'data-testid'?: string;
}

export function FormField({ label, htmlFor, children, 'data-testid': testId }: FormFieldProps) {
  return (
    <Field data-testid={testId}>
      <Label for={htmlFor}>{label}</Label>
      {children}
    </Field>
  );
}
